/** Map portal icon ids to display emoji (icon id is stored in the spec). */
export const ICON_EMOJI: Record<string, string> = {
  book: '📖',
  chart: '📊',
  clipboard: '📋',
  roadmap: '🗺️',
  settings: '⚙️',
  activity: '📈',
  'notebook-ai': '🤖',
  code: '💻',
  database: '🗄️',
  gear: '🔧',
  users: '👥',
  folder: '📁',
  file: '📄',
  star: '⭐',
  rocket: '🚀',
};

export function iconEmoji(id: string): string {
  return ICON_EMOJI[id] || '📦';
}
